import jwtDecode from 'jwt-decode'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { updateSession } from 'session'
import { Content, Form, Indicators } from 'ui'

interface TokenViewParams {
  token?: string
}

export const TokenView: React.FC = () => {
  const { token } = useParams<TokenViewParams>()
  const dispatch = useDispatch()
  const [error, setError] = useState('')
  const history = useHistory()
  useEffect(() => {
    if (token) {
      try {
        const { redirectPath } = jwtDecode(token) as {
          [key: string]: string
        }
        dispatch(updateSession({ temporaryAccessToken: token }))
        history.replace(redirectPath)
        return
      } catch (e) {
        // tslint:disable-next-line
        console.log(e)
      }
      setError('This access token link is invalid or may have expired.')
    }
  }, [token, dispatch, history])
  const returnHome = () => history.replace('/')
  return (
    <div className="h-screen v-screen">
      <div className="flex flex-col m-auto" style={{ maxWidth: '468px' }}>
        {error.length > 0 ? (
          <Content.Region>
            <Content.Heading>Sorry We Had a Problem</Content.Heading>
            <Content.Body>{error}</Content.Body>
            <Form.Button onClick={returnHome}>
              Click Here to Continue
            </Form.Button>
          </Content.Region>
        ) : (
          <Indicators.Spinner />
        )}
      </div>
    </div>
  )
}
